import "./App.css";
import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import TokenFactory from "./artifacts/contracts/TokenFactory.sol/TokenFactoryRemix.json";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  Spinner,
  Alert,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const POLYGON_CHAIN_ID = 137;
// const MUMBAI_CHAIN_ID = 80001;
const networkMap = {
  POLYGON_MAINNET: {
    chainId: "0x89", // 137
    chainName: "Matic(Polygon) Mainnet",
    nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
    rpcUrls: ["https://polygon-rpc.com"],
    blockExplorerUrls: ["https://www.polygonscan.com/"],
  },
  MUMBAI_TESTNET: {
    chainId: "0x13881", // 80001
    chainName: "Matic(Polygon) Mumbai Testnet",
    nativeCurrency: { name: "tMATIC", symbol: "tMATIC", decimals: 18 },
    rpcUrls: ["https://rpc-mumbai.maticvigil.com"],
    blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
  },
};
function TokenPage() {
  const [userAccount, setUserAccount] = useState();
  const [amount, setAmount] = useState();
  const [deployedContractAddress, setContract] = useState();
  const [formInput, updateFormInput] = useState({
    name: "",
    symbol: "",
    supply: 100000,
  });
  const [newToken, setNewToken] = useState();
  const [newTokenBalance, setNewTokenBalance] = useState();
  const [txSentHash, setTxSentHash] = useState();
  const [txPending, setTxPending] = useState(false);
  const [currNetwork, setCurrNetwork] = useState();
  const [errorMsg, setErrorMsg] = useState();

  useEffect(() => {
    refreshNetwork();

    if (window.ethereum) {
      window.ethereum.on("chainChanged", () => {
        console.log("chain changed");
        refreshNetwork();
      });
    }
  }, []);

  async function requestAccount() {
    await window.ethereum.request({ method: "eth_requestAccounts" });
  }

  async function refreshNetwork() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const network = await provider.getNetwork();
    console.log("current network: ", network);
    setCurrNetwork(network.chainId);
  }

  async function connectNetwork() {
    console.log("Connecting to polygon");
    // var chainId = ethers.utils.hexlify(networkMap.MUMBAI_TESTNET.chainId);

    // check if network is matic. if not, switch network
    if (currNetwork !== networkMap.POLYGON_MAINNET.chainId) {
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [networkMap.POLYGON_MAINNET],
      });
    }

    // After switching network, refresh
    refreshNetwork();
  }

  async function getBalance(tokenAddress) {
    if (typeof window.ethereum !== "undefined") {
      const [account] = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log("[getBalance] Current account: ", account);

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const contract = new ethers.Contract(
        tokenAddress,
        TokenFactory.abi,
        provider
      );
      const balance = await contract.balanceOf(account);
      const formattedBalance = ethers.utils.formatEther(balance);
      console.log(
        "[getBalance] Account's balance of custom token: ",
        formattedBalance
      );
      return formattedBalance;
    }
  }

  async function sendTokens() {
    if (typeof window.ethereum !== "undefined") {
      await requestAccount();
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        deployedContractAddress,
        TokenFactory.abi,
        signer
      );
      const amountInDecimals = ethers.utils.parseUnits(amount);
      console.log(
        "[sendTokens] Sending " +
          amountInDecimals +
          " tokens to recipient " +
          userAccount
      );

      await fetch("/api/logInfo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: {
            action: "send_token",
            recipient: userAccount,
            amountInDecimals: amountInDecimals,
          },
        }),
      });

      try {
        const transaction = await contract.transfer(
          userAccount,
          amountInDecimals
        );
        setTxPending(true);
        const receipt = await transaction.wait();
        setTxPending(false);
        console.log("[sendTokens] Transaction receipt: ", receipt);
        setTxSentHash(receipt.transactionHash);

        console.log(
          `[sendTokens] ${amountInDecimals} Coins successfully sent to ${userAccount}`
        );
        await fetch("/api/logSuccess", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              action: "send_token_successful",
              recipient: userAccount,
              receipt: receipt,
            },
          }),
        });
        // update the owner's balance
        const newBalance = await getBalance(deployedContractAddress);
        setNewTokenBalance(newBalance.toString());
      } catch (error) {
        console.log("something went wrong when sending tokens: ", error);
        setErrorMsg(JSON.stringify(error.data));

        await fetch("/api/logError", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              action: "send_token_failed",
              error: error,
              recipient: userAccount,
            },
          }),
        });
      }
    }
  }

  async function issueToken() {
    const { name, symbol, supply } = formInput;
    if (!name || !symbol) return alert("Missing name or symbol");
    console.log(
      `[issueToken] issuing token with name ${name} and symbol ${symbol}, supply of ${supply}`
    );

    await fetch("/api/logInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: { action: "issue_token", name: name, symbol: symbol },
      }),
    });

    // do not proceed if wallet not connected

    const provider = new ethers.providers.Web3Provider(window.ethereum);

    const accounts = await provider.listAccounts();
    console.log("connected accounts: ", accounts);
    await fetch("/api/logInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: accounts }),
    });
    if (accounts.length === 0) {
      console.log("no accounts");
      alert("Please connect your wallet and use the Polygon network");
    }

    const signer = provider.getSigner();

    const factory = new ethers.ContractFactory(
      TokenFactory.abi,
      TokenFactory.bytecode,
      signer
    );
    console.log("[issueToken] contract factory: ", factory);
    const contract = await factory.deploy(name, symbol, supply);
    setTxPending(true);
    try {
      const deployment = await contract.deployTransaction.wait();
      console.log("contract deployment: ", deployment);
      await contract.deployed();
      setTxPending(false);
      console.log(
        `[issueToken] Deployment successful! Contract Address: ${contract.address}`
      );

      await fetch("/api/logSuccess", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: {
            action: "issue_token_successful",
            name: name,
            symbol: symbol,
            address: contract.address,
            transaction: deployment,
          },
        }),
      });

      setNewToken(symbol);
      const balance = await getBalance(contract.address);
      setContract(contract.address);
      console.log("[issueToken] Balance of new token: ", balance.toString());

      setNewTokenBalance(balance);
    } catch (error) {
      console.error(error);
      setErrorMsg(JSON.stringify(error.data));
      await fetch("/api/logError", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: {
            action: "issue_token_error",
            name: name,
            symbol: symbol,
            error: error,
          },
        }),
      });
    }
  }

  async function addToWallet() {
    const address = deployedContractAddress;
    const symbol = newToken;
    const decimals = 18;
    const image = "";
    try {
      const tokenAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: address,
            symbol: symbol,
            decimals: decimals,
            image: image,
          },
        },
      });
      if (tokenAdded) {
        console.log("Token successfully added to wallet");
      } else {
        console.log("Something went wrong when adding token");
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function reset() {
    setContract();
  }

  return (
    <div className="App">
      <header className="App-header">
        <div>
          <img
            src="axe-dynamic-premium.png"
            className="header-img"
            alt="axe"
          ></img>
          <h1 className="text-gradient text-glow">
            <b>Issue a token in 1 click</b>
          </h1>
          <div>
            {deployedContractAddress ? (
              <div>
                Token successfully created! <b>{formInput.symbol}</b> was
                deployed to{" "}
                <a
                  className="tx-hash"
                  href={
                    networkMap.POLYGON_MAINNET.blockExplorerUrls[0] +
                    "address/" +
                    deployedContractAddress
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {deployedContractAddress}
                </a>
                <p>
                  You now have {newTokenBalance} of {newToken}.{" "}
                </p>
                <Button
                  variant="secondary"
                  onClick={addToWallet}
                  className="btn-gradient btn-glow token-btn"
                >
                  👛 Add to Wallet
                </Button>
                <Button
                  variant="secondary"
                  onClick={reset}
                  className="btn-gradient btn-glow"
                >
                  🔨 Mint Another
                </Button>
                <Container className="mt-5" style={{ width: "60%" }}>
                  <Card style={{ color: "#000" }} className="new-token-card">
                    <h3 className="text-gradient text-glow mt-3">
                      Send your tokens
                    </h3>
                    <Card.Body>
                      <Form className="send-token-form">
                        <Row>
                          <Col>
                            {" "}
                            <Form.Group>
                              <Form.Control
                                onChange={(e) => setUserAccount(e.target.value)}
                                placeholder="Recipient Account ID"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col>
                            {" "}
                            <Form.Group>
                              {/* <Form.Label>Recipient Address</Form.Label> */}
                              <Form.Control
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Amount"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                      {txPending ? (
                        <h4>
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">
                              Processing...
                            </span>
                          </Spinner>
                        </h4>
                      ) : (
                        ""
                      )}
                      <Button
                        onClick={sendTokens}
                        className="btn-gradient-2 btn-glow mt-3"
                      >
                        🪙 Send Tokens
                      </Button>
                      {txSentHash ? (
                        <p>
                          {" "}
                          Transfer{" "}
                          <a
                            href={
                              networkMap.POLYGON_MAINNET.blockExplorerUrls[0] +
                              "tx/" +
                              txSentHash
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            confirmed
                          </a>
                          : {txSentHash}
                        </p>
                      ) : (
                        ""
                      )}
                    </Card.Body>
                  </Card>
                </Container>
              </div>
            ) : (
              <div>
                <p className="text-glow">
                  Your custom ERC20 on Polygon in less than a minute, {"<"}
                  $0.1 in fees
                </p>

                <Container style={{ width: "90%" }}>
                  {/* <Alert variant="danger" className="alert">
                    🎉 <b>THANK YOU</b> for the huge support that led us to{" "}
                    <a
                      href="https://www.producthunt.com/posts/lua"
                      target="_blank"
                      rel="noreferrer"
                    >
                      #1 Product of the Day
                    </a>{" "}
                    on Product Hunt! Due to a high volume of feature requests,
                    Lua is temporarily running on the Mumbai testnet while we
                    make improvements and address your requests. See{" "}
                    <a
                      href="https://docs.polygon.technology/docs/develop/network-details/network/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      here
                    </a>{" "}
                    for info on obtaining testnet Matic.
                  </Alert> */}
                  <Card
                    className="mb-3 mt-3 new-token-card"
                    style={{ color: "#000" }}
                  >
                    <Card.Body>
                      <Form>
                        <Row>
                          <Col>
                            <Form.Group controlId="formTokenName">
                              <Form.Label>Token Name</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Shiba Token"
                                onChange={(e) =>
                                  updateFormInput({
                                    ...formInput,
                                    name: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group controlId="formTokenSymbol">
                              <Form.Label>Symbol</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="SHIB"
                                onChange={(e) =>
                                  updateFormInput({
                                    ...formInput,
                                    symbol: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Form.Group>
                            <Form.Label>Supply</Form.Label>
                            <Form.Control
                              type="text"
                              // placeholder="Supply"
                              defaultValue={formInput.supply}
                              onChange={(e) =>
                                updateFormInput({
                                  ...formInput,
                                  supply: e.target.value,
                                })
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Row>
                        <Alert variant="warning" className="alert">
                          ⚠️ This deploys a generic ERC20 token to the Polygon
                          network. View the contract implementation{" "}
                          <a
                            href="https://docs.openzeppelin.com/contracts/3.x/api/token/erc20#IERC20"
                            target="_blank"
                            rel="noreferrer"
                          >
                            here
                          </a>
                          . By default, ERC20s have 18 decimals.
                        </Alert>
                      </Form>
                    </Card.Body>
                  </Card>
                  {txPending ? (
                    <h4>
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Processing...</span>
                      </Spinner>
                    </h4>
                  ) : (
                    ""
                  )}

                  {currNetwork === POLYGON_CHAIN_ID ? (
                    <Button
                      className="btn btn-gradient btn-glow"
                      onClick={issueToken}
                    >
                      🔨 Issue Token
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-gradient btn-glow"
                      onClick={connectNetwork}
                    >
                      CONNECT TO POLYGON
                    </Button>
                  )}
                </Container>
              </div>
            )}
          </div>
          <div className="error-div">
            {errorMsg ? (
              <Alert variant="danger">
                Oops, something went wrong! Please make sure your Metamask
                wallet is connected to Lua, and that you are on the Polygon
                network. If issues persist, reach out to <b>hello@lua.cash</b>
                <p>{errorMsg}</p>
              </Alert>
            ) : (
              ""
            )}
          </div>
        </div>
      </header>
    </div>
  );
}

export default TokenPage;
